import React, { useState, useEffect } from "react";
import getComponent from "../../_Case/ComponentsList";
import { useSelector, shallowEqual } from "react-redux"

const AMFRInvestigationDetailsComponent = ({ myName, getValue, setValue, formComponentData }) => { 
  const defaultState = {
    productDesignation: "",
    quantity: "",
    skfBearingDesignation: "",
    customerIdRefrenceNumber: "",
    competitorBearing: "",
    subHeader: "",
    application: "",
    vehicleNumber: "",
    carSalesDate: "",
    carRepairDate: "",
    carType: "",
    duration: "",
    problemDetails: "",
    problemDescription: "",
  };

  const [state, setState] = useState(defaultState);
  const [isAMFR, setIsAMFR] = useState(false);
  const gbiTypeAnswer = useSelector(state => state.saveComponentValue.components.find(a => a.name === "TERorAMFRorOther"), shallowEqual);

  useEffect(() => { 
    if (gbiTypeAnswer !== undefined) {
      let parsedResult = JSON.parse(gbiTypeAnswer.value)
      if (parsedResult.GBIReportType.value === "AMFR") {
        setIsAMFR(true);
      } else {
        setIsAMFR(false);
      }
    } else {
      setIsAMFR(false);
    }
  }, [gbiTypeAnswer]);

  useEffect(() => { 
    const result = getValue(myName);
    if (result) {
      setState(result);
    } else { 
      setState(defaultState);
    }
  }, [getValue, myName]);

  const handleChange = (value, name) => { 
    let resultName = name.split(".").pop();
    let objectToSave = { ...state };
    objectToSave[resultName] = value;
    setState(objectToSave);
    setValue(objectToSave, myName);
  }

  const renderOther = (formComponent, index) => { 
    return <React.Fragment key={index}>{getComponent(
      formComponent,
      `${myName}.${formComponent.key}`,
      handleChange,
      state[formComponent.key]
    )}</React.Fragment>
  }

  return (
    isAMFR ? 
    <>
      {formComponentData.args.map((formComponent, index) => {
        return renderOther(formComponent, index);
      })}
    </>
    : null
  );

}

export default AMFRInvestigationDetailsComponent;